<!--parent-->
<ng-container *ngIf="data$ | async as data">
  @let trustpilot = trustpilot$ | async;
  @if (trustpilot && trustpilot?.show) {
    <app-gg-trustpilot [trustpilot]="trustpilot"></app-gg-trustpilot>
  }
  <div class="footer-links-container">
    <div class="footer-links">
      <ng-container *ngFor="let link of links$ | async">
        <ng-template [cxComponentWrapper]="{ flexType: link.typeCode, typeCode: link.typeCode, uid: link?.uid }">
        </ng-template>
      </ng-container>
    </div>
  </div>
  <div *ngIf="linkList$ | async as linkList" class="payment-links-container">
    <ng-container *ngFor="let iconLink of linkList">
      <ng-container *ngIf="iconLink.link; else noLink">
        <cx-generic-link [target]="'_blank'" [url]="iconLink.link.url ?? ''">
          <img class="payment-icon {{ iconLink.iconClass }}" alt="{{ iconLink.link.url }}" />
        </cx-generic-link>
      </ng-container>
      <ng-template #noLink>
        <img class="payment-icon {{ iconLink.iconClass }}" alt="{{ iconLink.iconClass }}" />
      </ng-template>
    </ng-container>
  </div>
  <div class="bottom-links-container">
    <ng-container *ngFor="let children of data.navigationNode.children">
      <ng-container *ngFor="let entry of children.entries">
        <ng-template [cxComponentWrapper]="{ flexType: entry.itemType, typeCode: entry.itemType, uid: entry?.itemId }">
        </ng-template>
      </ng-container>
    </ng-container>
    <ul class="bottom-links">
      <li *ngFor="let entry of data.navigationNode.entries">
        <ng-template
          [cxComponentWrapper]="{
            flexType: entry.itemType,
            typeCode: entry.itemType,
            uid: entry?.itemId,
          }"
        >
        </ng-template>
      </li>
      @if (!(logged$ | async)) {
        <li>
          <cx-anonymous-consent-open-dialog />
        </li>
      }
    </ul>
    <div class="copyright">{{ data.notice }}</div>
  </div>
</ng-container>
